import type { IDialogMessage } from '../interface';

export const MESSAGE_DEFAULTS: Omit<Required<IDialogMessage>, 'id'> = {
    title: '',
    show: false,
    textAccept: 'OK',
    textDecline: 'Cancel',
    onAccept: () => {
        /* No-Op */
    },
    onDecline: () => {
        /* No-Op */
    },
    options: { removeOnHide: true },
};
